import { render, staticRenderFns } from "./searchWord.vue?vue&type=template&id=e81fed1a&scoped=true&"
import script from "./searchWord.vue?vue&type=script&lang=js&"
export * from "./searchWord.vue?vue&type=script&lang=js&"
import style0 from "./searchWord.vue?vue&type=style&index=0&id=e81fed1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81fed1a",
  null
  
)

export default component.exports